import cn from "classnames"
import React, { useState } from "react"
import { IStandardButtonProps, StandardButton } from "swiipe.portal.shared"
import SpinnerContainer from "./SpinnerContainer"
import "./StickyButton.scss"

interface IStickyButtonProps extends IStandardButtonProps {
    containerClass?: string
    contentLeft?: React.ReactNode
}

const StickyButton = ({ disabled, className, children, containerClass, contentLeft, ...otherProps }: IStickyButtonProps) => {
    const [isLoading, setIsLoading] = useState(false)

    return (
        <SpinnerContainer
            showSpinner={isLoading}
            className={cn("sticky-button", containerClass)}
            wrapperClassName="sticky-button__wrapper"
        >
            {contentLeft && <div className="sticky-button__content-left">{contentLeft}</div>}
            <StandardButton
                {...otherProps}
                className={cn("sticky-button__btn", className)}
                disabled={disabled}
                variant="primary"
                onClick={async (event) => {
                    setIsLoading(true)
                    try {
                        if (otherProps.onClick) {
                            await otherProps.onClick(event)
                        }
                    } finally {
                        setIsLoading(false)
                    }
                }}
            >
                {children}
            </StandardButton>
        </SpinnerContainer>
    )
}

export default StickyButton
